import * as React from 'react';
import { Link } from 'gatsby';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserGroup,
  faHouse,
  faRankingStar,
  faNewspaper,
  faBookOpen,
  faCube,
  faDiceFive,
  faDungeon,
  faCalculator,
  faDove,
  faHourglassHalf
} from '@fortawesome/free-solid-svg-icons';
import { useLocation } from '@reach/router';
import { Nav } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../../state/Store';
import { ToggleMenu } from '../../../layout/actions/Layout.actions';
import { faApple } from '@fortawesome/free-brands-svg-icons';

export const HSRMenu: React.FC = () => {
  const pathFragments = useLocation()
    .pathname.split('/')
    .filter((p) => p && p.trim().length > 0);
  const activeKey = pathFragments.length < 1 ? 'home' : pathFragments[0];

  const model = useSelector((state: RootState) => ({
    layout: state.layout
  }));

  const dispatch = useDispatch();

  const handleOnClick = () => {
    if (model.layout.isMenuVisible === true) {
      dispatch(ToggleMenu());
    }
  };

  return (
    <Nav className="ms-auto" activeKey={activeKey}>
      <Link to="/star-rail/">
        <Nav.Link as="span" eventKey="home" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHouse} width="18" /> <span>Home</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/characters">
        <Nav.Link as="span" eventKey="characters" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faUserGroup} width="18" />{' '}
          <span>Characters</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/tier-list">
        <Nav.Link as="span" eventKey="tier-list" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faRankingStar} width="18" />{' '}
          <span>Tier list</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/memory-of-chaos">
        <Nav.Link as="span" eventKey="items" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faDungeon} width="18" />{' '}
          <span>Memory of Chaos</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/pure-fiction">
        <Nav.Link as="span" eventKey="items" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faDove} width="18" /> <span>Pure Fiction</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/apocalyptic-shadow">
        <Nav.Link as="span" eventKey="items" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faHourglassHalf} width="18" />{' '}
          <span>Apocalyptic Shadow</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/light-cones">
        <Nav.Link as="span" eventKey="light-cones" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faCube} width="18" /> <span>Light Cones</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/guides/relic-sets">
        <Nav.Link as="span" eventKey="relics" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faDiceFive} width="18" /> <span>Relics</span>
        </Nav.Link>
      </Link>
      <hr />
      <Link to="/star-rail/guides/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faBookOpen} width="18" /> <span>Guides</span>
        </Nav.Link>
      </Link>
      <Link to="/star-rail/tools/">
        <Nav.Link as="span" eventKey="guides" onClick={handleOnClick}>
          <FontAwesomeIcon icon={faCalculator} width="18" /> <span>Tools</span>
        </Nav.Link>
      </Link>
      <hr />
      <a href="https://blog.prydwen.gg/category/honkai-star-rail/">
        <Nav.Link as="span" eventKey="blog">
          <FontAwesomeIcon icon={faNewspaper} width="18" /> <span>Blog</span>
        </Nav.Link>
      </a>
      <hr />
      <Link to="/star-rail/play-on-mac">
        <Nav.Link
          as="span"
          className="special"
          eventKey="play-on-mac"
          onClick={handleOnClick}
        >
          <FontAwesomeIcon icon={faApple} width="18" /> <span>Play on Mac</span>
        </Nav.Link>
      </Link>
    </Nav>
  );
};
